// React imports.
import * as React from 'react';


/**
 * Stateless functional components, renders an error component.
 *
 * @param props The propagated properties.
 * @returns {JSX.Element} The element that needs to be rendered.
 */
const Error = (props: {}): JSX.Element => (
  <div>
    Exercise not found
  </div>
);

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.tsx